import {
	Col,
	Form,
	Input,
	Modal,
	Row,
	Flex,
	Typography,
	Button,
	Image,
} from "antd";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";

const { Title, Text } = Typography;

const JobSiteType = ({ load }) => {
	const [form] = Form.useForm();
	const [openSlumpModal, setOpenSlumpModal] = useState(false);
	const [openTemperatureModal, setOpenTemperatureModal] = useState(false);
	const [initialValues, setInitialValues] = useState({});

	useEffect(() => {
		if (load) {
			setInitialValues({
				jobSiteSlump: load.jobSiteSlump || 0,
				jobSiteSlumpUrl: load.jobSiteSlumpUrl,
				jobSiteTemperature: load.jobSiteTemperature
					? `${load.jobSiteTemperature} °F`
					: "0",
				jobSiteTemperatureUrl: load.jobSiteTemperatureUrl,
				jobSiteDrumRotation: load.jobSiteDrumRotation || 0,
				jobSiteWaterAdded: load.jobSiteWaterAdded || 0,
				jobSiteAmbientTemperature: load.jobSiteAmbientTemperature
					? `${load.jobSiteAmbientTemperature} °F`
					: "0",
				jobSiteWindSpeed: load.jobSiteWindSpeed
					? `${load.jobSiteWindSpeed} mph`
					: "0",
				toJobDate: load.toJobDate
					? dayjs(load.toJobDate)
							.add(6, "h")
							.add(90, "m")
							.format("MM/DD/YYYY hh:mm:ss A")
					: "-",
				startUnloadDate: load.startUnloadDate
					? dayjs(load.startUnloadDate)
							.add(6, "h")
							.format("MM/DD/YYYY hh:mm:ss A")
					: "-",
				finishUnloadDate: load.finishUnloadDate
					? dayjs(load.finishUnloadDate)
							.add(6, "h")
							.format("MM/DD/YYYY hh:mm:ss A")
					: "-",
			});
		}
	}, [load]);

	const handleSlumpModal = () => {
		setOpenSlumpModal((prev) => !prev);
	};

	const RenderSlumpModal = () => {
		return (
			<Modal
				title={`Slump image in load ${load.deliveryTicket}`}
				open={openSlumpModal}
				onCancel={handleSlumpModal}
				cancelButtonProps={{ style: { display: "none" } }}
				okButtonProps={{ style: { display: "none" } }}
				width={1000}
			>
				<Image width={"100%"} src={load.jobSiteSlumpUrl} />
			</Modal>
		);
	};

	const handleTemperatureModal = () => {
		setOpenTemperatureModal((prev) => !prev);
	};

	const RenderTemperatureModal = () => {
		return (
			<Modal
				title={`Temperature image in load ${load.deliveryTicket}`}
				open={openTemperatureModal}
				onCancel={handleTemperatureModal}
				cancelButtonProps={{ style: { display: "none" } }}
				okButtonProps={{ style: { display: "none" } }}
				width={1000}
			>
				<Image width={"100%"} src={load.jobSiteTemperatureUrl} />
			</Modal>
		);
	};

	const CustomForm = () => {
		return (
			<Form
				form={form}
				layout="vertical"
				style={{ marginTop: "20px" }}
				initialValues={initialValues}
			>
				<Row gutter={16}>
					<Col span={12} md={8}>
						<Form.Item label="Slump" name="jobSiteSlump">
							<Input size="large" readOnly />
						</Form.Item>
					</Col>
					<Col span={12} md={8}>
						<Form.Item label="Slump Image" name="jobSiteSlumpUrl">
							{load.jobSiteSlumpUrl ? (
								<Button type="primary" size="large" onClick={handleSlumpModal}>
									View Image
								</Button>
							) : (
								<Text>No image attached</Text>
							)}
						</Form.Item>
					</Col>
					<Col span={12} md={8}>
						<Form.Item label="Temperature" name="jobSiteTemperature">
							<Input size="large" readOnly />
						</Form.Item>
					</Col>
					<Col span={12} md={8}>
						<Form.Item label="Temperature Image" name="jobSiteTemperatureUrl">
							{load.jobSiteTemperatureUrl ? (
								<Button
									type="primary"
									size="large"
									onClick={handleTemperatureModal}
								>
									View Image
								</Button>
							) : (
								<Text>No image attached</Text>
							)}
						</Form.Item>
					</Col>

					<Col span={12} md={8}>
						<Form.Item label="Drum Rotation" name="jobSiteDrumRotation">
							<Input size="large" readOnly />
						</Form.Item>
					</Col>
					<Col span={12} md={8}>
						<Form.Item label="Water Added" name="jobSiteWaterAdded">
							<Input size="large" readOnly />
						</Form.Item>
					</Col>
					<Col span={12} md={8}>
						<Form.Item label="Site Arrival Time" name="toJobDate">
							<Input size="large" readOnly />
						</Form.Item>
					</Col>
					<Col span={12} md={8}>
						<Form.Item label="Start Unload" name="startUnloadDate">
							<Input size="large" readOnly />
						</Form.Item>
					</Col>
					<Col span={12} md={8}>
						<Form.Item label="End Unload" name="finishUnloadDate">
							<Input size="large" readOnly />
						</Form.Item>
					</Col>
					<Col span={12} md={8}>
						<Form.Item
							label="Ambient Temperature"
							name="jobSiteAmbientTemperature"
						>
							<Input size="large" readOnly />
						</Form.Item>
					</Col>
					<Col span={12} md={8}>
						<Form.Item label="Wind Speed" name="jobSiteWindSpeed">
							<Input size="large" readOnly />
						</Form.Item>
					</Col>
				</Row>
			</Form>
		);
	};

	return (
		<Flex vertical>
			<Title level={1}>Job Site</Title>
			<CustomForm />
			<RenderSlumpModal />
			<RenderTemperatureModal />
		</Flex>
	);
};

export default JobSiteType;
